
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.34340',
  depVersions: {
  "documents-public-ui": "static-1.34340",
  "client-types": "static-1.457",
  "documents-lib": "static-1.34345",
  "emoji-mart": "static-3.4",
  "foundations-theming-specialty": "static-1.2068",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.4938",
  "highcharts": "static-8.102",
  "hs-promise-utils": "static-1.5531",
  "hs-test-utils": "static-1.7950",
  "hub-http": "static-1.6157",
  "hubspot-dlb": "static-2.1832",
  "HubStyleTokens": "static-2.11397",
  "I18n": "static-7.1610",
  "jasmine-immutable": "static-1.2955",
  "jasmine-runner": "static-1.6406",
  "lodash": "static-1.3",
  "quartz": "static-1.6930",
  "react": "static-7.184",
  "react-dlb": "static-1.77",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-redux": "static-7.70",
  "react-rhumb": "static-1.16597",
  "reporting-data": "static-1.67207",
  "reporting-testing-lib": "static-1.9140",
  "reporting-visualizations": "static-1.59283",
  "tinymce": "static-6.5",
  "ui-addon-draggable": "static-3.4706",
  "webpack-env": "static-1.54",
  "atom": "static-1.5007",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2431",
  "classnames": "static-2.10",
  "cssUtils": "static-1.778",
  "customer-data-filters-ui": "static-1.39512",
  "customer-data-objects": "static-1.7598",
  "customer-data-property-utils": "static-1.8019",
  "data-fetching-client": "static-1.9611",
  "enviro": "static-4.428",
  "FireAlarmUi": "static-1.4465",
  "flux-actions": "static-1.329",
  "FormsCommonComponents": "static-1.85656",
  "FormUrlGenerator": "static-2.4656",
  "foundations-components": "static-1.7802",
  "history": "static-4.47",
  "hs-lodash": "static-4.45",
  "hubspot-url-utils": "static-1.4049",
  "HubStyle": "static-2.11705",
  "icons": "static-2.643",
  "immutable": "static-2.77",
  "isMobile": "static-1.7",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.7095",
  "metrics-js": "static-1.9542",
  "PatternValidationJS": "static-1.437",
  "pdf-js": "static-2.49",
  "PortalIdParser": "static-2.388",
  "property-description-translator": "static-1.3784",
  "property-translator": "static-1.5339",
  "quartz-config": "static-1.708",
  "quartz-core": "static-1.6149",
  "quick-fetch": "static-1.3868",
  "raven": "static-3.5829",
  "react-dom": "static-7.85",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-router-dom": "static-5.26",
  "react-select-plus": "static-1.103",
  "react-utils": "static-2.5295",
  "react-virtualized": "static-2.97",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.8106",
  "reference-resolvers-lite": "static-1.8028",
  "report-customization-components": "static-1.12937",
  "reporting-enablement": "static-1.22638",
  "reporting-reports": "static-1.66885",
  "reporting-snowflake": "static-1.55825",
  "reporting-ui-components": "static-2.64478",
  "reselect": "static-2.16",
  "rpc-client-utils": "static-1.4581",
  "sales-content-partitioning": "static-1.8873",
  "SalesContentIndexUI": "static-3.9147",
  "sanitize": "static-1.4409",
  "sanitize-text": "static-1.8081",
  "self-service-api": "static-1.10182",
  "SharedI18nStrings": "static-1.182",
  "SharedLegalStrings": "static-1.1683",
  "signup-constants": "static-1.18729",
  "signup-ui-lego-core": "static-1.20739",
  "signup-ui-url-generator": "static-2.7972",
  "styled-components": "static-2.88",
  "StyleGuideUI": "static-3.485",
  "superstore": "static-1.4705",
  "transmute": "static-2.85",
  "ui-addon-form-validation": "static-1.10927",
  "ui-addon-i18n": "static-1.11087",
  "ui-addon-react-router-dom": "static-1.9481",
  "ui-addon-upgrades": "static-9.17893",
  "ui-asset-management-lib": "static-1.10936",
  "ui-images": "static-2.1138",
  "UIComponents": "static-3.8344",
  "usage-tracker": "static-1.7273",
  "usage-tracker-container": "static-1.7263",
  "usage-tracker-core": "static-1.7123",
  "usage-tracker-public": "static-1.7084",
  "viral-links-lib": "static-1.6988",
  "hs-promise-rejection-tracking": "static-1.5489",
  "raven-hubspot": "static-1.6136",
  "hoist-non-react-statics": "static-3.9",
  "bend-plugin-trellis-migration": "static-1.3355",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3207",
  "quartz-webpack": "static-1.3154",
  "ai-components-ui-library": "static-1.8770",
  "amplitude-session-replay-browser": "static-1.58",
  "foundations-assets": "static-1.4789",
  "foundations-theming": "static-1.4352",
  "quartz-auth": "static-1.605",
  "ui-business-units-lib": "static-1.8980",
  "usage-tracker-session-replay": "static-1.4959",
  "foundations-theming-base": "static-1.3337",
  "HeadJS": "static-2.740",
  "framer-motion": "static-1.70",
  "hs-test-utils-bend-plugin": "static-1.3061",
  "msw": "static-1.39",
  "testing-library": "static-1.150",
  "hs-locale-management": "static-1.35",
  "i18n-data": "static-1.219",
  "moment-timezone": "static-5.81",
  "jasmine": "static-4.4261",
  "csstype": "static-1.50",
  "quartz-head": "static-1.595",
  "frontend-preferences-client": "static-1.7862",
  "graphql": "static-1.80",
  "immer": "static-1.33",
  "inbound-db-meta-service-client": "static-1.3542",
  "persist-promise": "static-1.3646",
  "quartz-i18n": "static-1.605",
  "reporting-client-types": "static-1.2454",
  "foundations-components-legacy": "static-1.827",
  "hs-story-utils": "static-1.9366",
  "react-flip-move": "static-1.68",
  "hub-http-shared-msw-handlers": "static-1.9810",
  "hubspotter-http": "static-1.4603",
  "sassPrefix": "static-1.154",
  "conversations-skeleton-state": "static-1.7187",
  "crm-message-bus": "static-1.42795",
  "customer-data-filters-ui-msw-helpers": "static-1.21947",
  "customer-data-objects-ui-components": "static-1.12958",
  "customer-data-reference-ui-components": "static-1.13092",
  "customer-data-ui-utilities": "static-1.9763",
  "framework-builder-read-service-client": "static-1.3961",
  "framework-data-schema-quick-fetch": "static-1.6717",
  "framework-data-schema-resolvers": "static-1.6812",
  "inbound-db-properties-service-client": "static-1.3793",
  "multi-account-reference-resolvers": "static-1.913",
  "onboarding-tours": "static-1.16473",
  "reporting-datasets-permissions-lib": "static-1.13471",
  "ui-addon-teams": "static-1.21463",
  "apollo-stack-hubspot": "static-3.84",
  "fast-json-stable-stringify": "static-1.4",
  "ContentUtils": "static-1.68157",
  "customer-data-properties": "static-1.51302",
  "forms-ai-lib": "static-1.4211",
  "forms-utils-lib": "static-1.12456",
  "foundations-components-test-utils": "static-1.5285",
  "react-dnd-compat": "static-1.4556",
  "react-tinymce": "static-1.55048",
  "tinymce-config": "static-2.54174",
  "ui-gdpr-components": "static-1.10283",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.4071",
  "floating-ui": "static-1.54",
  "react-aria": "static-1.64",
  "tanstack-table": "static-1.53",
  "trellis-assets": "static-1.1621",
  "ui-fonts": "static-1.659",
  "dispatcher": "static-1.135",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.826",
  "mobile-manifest-mixins": "static-1.514",
  "module-federation": "static-1.21",
  "quartz-routing": "static-1.360",
  "quartz-test": "static-1.605",
  "quartz-tracking": "static-1.309",
  "batch-promise": "static-1.1489",
  "external-options-client-types": "static-1.4110",
  "react-colorpicker": "static-2.10146",
  "copilot-toolkit": "static-1.10944",
  "data-quality-ui-library": "static-1.12700",
  "html-to-image": "static-1.52",
  "onboarding-scopes": "static-1.6401",
  "reporting-action-components": "static-1.41115",
  "reporting-filters": "static-1.142",
  "reporting-insights-lib": "static-1.1522",
  "reporting-plugins": "static-1.10185",
  "ui-addon-draggable-compat": "static-2.4190",
  "ui-addon-opt": "static-4.8317",
  "zustand": "static-1.72",
  "growth-payments-core": "static-1.25162",
  "hubspot-apollo-client": "static-1.4815",
  "chirp-fetch": "static-1.1819",
  "sales-templates-service-types-lib": "static-1.4119",
  "merchandise-lib": "static-1.262",
  "emoji-regex": "static-1.7",
  "purchase-motions-components": "static-1.5764",
  "salesImages": "static-1.523",
  "ts-schema": "static-1.4029",
  "nested-table": "static-1.163",
  "timezone-utils": "static-2.5180",
  "bender-build-tools": "static-1.3093",
  "chatspot-core": "static-1.20970",
  "bend-plugin-foundations-theming": "static-1.2835",
  "stylex": "static-1.31",
  "hubspotter-http-shared-msw-handlers": "static-1.9808",
  "react-immutable-render-mixin": "static-1.9",
  "conditional-properties-service-client": "static-1.3748",
  "crm-pipelines-api-client-types": "static-1.4094",
  "multi-currency-client-types": "static-1.3643",
  "getting-started-shared-tasks": "static-1.18304",
  "growth-data-modal": "static-1.5322",
  "growth-onboarding-confetti": "static-1.3006",
  "growth-onboarding-next-action-utils": "static-1.1711",
  "navigation-components": "static-1.17799",
  "onboarding-tours-client": "static-1.4687",
  "onboarding-tours-utils": "static-1.539",
  "ui-shepherd-react": "static-3.10085",
  "ui-shepherd-tracker": "static-1.7466",
  "ui-universal-auth": "static-1.8894",
  "user-context": "static-1.5036",
  "cms-field-types": "static-1.4746",
  "content-icons-ui": "static-1.2211",
  "integrations-lib": "static-1.15893",
  "calling-global-api": "static-1.64261",
  "calling-internal-common": "static-1.31239",
  "calling-lifecycle-internal": "static-1.65643",
  "calling-lifecycle-messages": "static-1.57937",
  "commerce-products-lib": "static-1.9273",
  "crm-links": "static-1.6215",
  "customer-data-properties-shared-msw-handlers": "static-1.9137",
  "file-manager-components": "static-1.23420",
  "google-libphonenumber": "static-1.36",
  "hs-resources": "static-1.77",
  "inbounddb-objects-service-types": "static-1.4175",
  "meetings-icalendar-utils-lib": "static-1.567",
  "object-builder-ui-client": "static-1.48507",
  "pipeline-validation-client-types": "static-1.3917",
  "property-value-citations": "static-1.1916",
  "pulse": "static-1.488",
  "smart-property-lib": "static-1.6599",
  "tiered-pricing": "static-1.1066",
  "ui-addon-iframeable": "static-1.8988",
  "final-form": "static-1.68",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.19716",
  "tinymce-themes": "static-1.56144",
  "data-token-picker": "static-1.16287",
  "hub-http-contrib": "static-1.2978",
  "interframe": "static-3.4699",
  "tinymce-data": "static-1.40259",
  "tinymce-plugins": "static-1.57288",
  "ui-addon-sales-email": "static-1.5148",
  "magpie-lib": "static-1.5519",
  "magpie-types": "static-1.4979",
  "simple-logging-lib": "static-1.2987",
  "content-assistance-lib": "static-1.7650",
  "dashboard-lib": "static-1.81254",
  "ExportDialog": "static-6.10328",
  "hubspot-prosemirror": "static-1.18036",
  "hubspot-prosemirror-plugins": "static-1.18028",
  "prosemirror": "static-1.13",
  "share-with-third-party-component-lib": "static-1.8633",
  "campaign-roi-lib": "static-1.8824",
  "feedback-loader": "static-1.29177",
  "apollo-link-hub-http": "static-2.4587",
  "hubspot-apollo-cache": "static-1.274",
  "purchase-motions-api": "static-1.5767",
  "trials-service-types": "static-1.3838",
  "react-window": "static-1.13",
  "ts-utils-lib": "static-1.110",
  "markdown-it": "static-1.6",
  "onboarding-data-sync-lib": "static-1.1846",
  "growth-onboarding-next-action-components": "static-1.1739",
  "user-context-client": "static-1.4548",
  "idb-keyval": "static-1.42",
  "nest": "static-1.160",
  "reactive-lib": "static-1.659",
  "unified-auth-core-lib": "static-1.689",
  "getting-started-shared-tasks-store": "static-1.17422",
  "integrations-error-boundary-lib": "static-1.13308",
  "integrations-tracking-lib": "static-1.5533",
  "native-integrations-shared-strings": "static-1.7722",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10310",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.408",
  "calling-error-reporting": "static-1.31245",
  "shared-worker-versioning": "static-1.10974",
  "calling-usage-tracker": "static-1.6477",
  "voice-sms-access-library": "static-1.715",
  "customer-data-tracking": "static-1.6821",
  "commerce-permissions": "static-1.703",
  "products-iframe-lib": "static-1.7734",
  "products-ui-components-shared-msw-handlers": "static-1.10192",
  "location-customization-utils-lib": "static-1.9033",
  "apollo-dlb": "static-3.86",
  "immerable": "static-1.4089",
  "video-components-external": "static-1.11048",
  "video-data-lib": "static-1.34706",
  "directed-graph": "static-1.874",
  "event-emitter": "static-1.884",
  "fast-json-patch": "static-1.61",
  "data-agent-kit": "static-1.88",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9893",
  "fsm": "static-1.3671",
  "policy-lib": "static-1.6712",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9956",
  "navigation-messaging": "static-1.7126",
  "FileManagerLib": "static-1.39060",
  "NamespacedHubStyle": "static-2.9015",
  "FileManagerCore": "static-1.38919",
  "codemirror": "static-5.93",
  "layout-dnd-components": "static-1.12316",
  "layout-dnd-utils": "static-1.11291",
  "react-codemirror": "static-1.10560",
  "ui-addon-emoji-picker": "static-1.9823",
  "ui-brand-identity-lib": "static-1.14946",
  "ui-addon-video-player": "static-1.8633",
  "ui-coaching-tips": "static-1.28351",
  "redux-actions": "static-3.7",
  "knowledge-content-types": "static-1.8479",
  "payment-link-components": "static-1.23338",
  "EmailSignatureEditor": "static-1.24228",
  "InboxConnectUtils": "static-4.14617",
  "universal-page-editor-lib": "static-1.2945",
  "google-sheets-integration-lib": "static-1.35",
  "microsoft-drive-integration-lib": "static-1.135",
  "calling-orchestration-schema": "static-1.35492",
  "sales-views-client-types": "static-1.4199",
  "crm-record-cards-service-types": "static-1.3562",
  "content-media-composition-data-lib": "static-1.12026",
  "content-media-compositions": "static-2.16033",
  "media-bridge-lib": "static-1.18810",
  "trellis-story-utils": "static-1.4454",
  "storybook-react": "static-1.31",
  "audio-components": "static-1.5814",
  "FileManagerImages": "static-1.36571",
  "video-components": "static-1.13051",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4468",
  "video-embed": "static-1.35540",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.68232",
  "layout-data-lib": "static-1.9616",
  "browser-eslint": "static-2.57",
  "growth-onboarding-feedback-components": "static-1.6519",
  "commerce-tours-lib": "static-1.5972",
  "growth-onboarding-reliability": "static-1.5020",
  "sales-checkout-service-client": "static-1.3576",
  "draft-convert": "static-2.71",
  "draft-extend": "static-3.73",
  "draft-js": "static-5.76",
  "draft-plugins": "static-2.21555",
  "sales-email-signature-service-client": "static-1.3779",
  "social-insights-client-types": "static-1.21881",
  "outpost": "static-1.4125",
  "advanced-menus-core": "static-1.15025",
  "advanced-menus-lib": "static-1.11980",
  "ui-memberships-settings-lib": "static-1.33855",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15024",
  "simple-menus-lib": "static-1.16541"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.34340",
  "client-types": "/client-types/static-1.457",
  "documents-lib": "/documents-lib/static-1.34345",
  "emoji-mart": "/emoji-mart/static-3.4",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2068",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.4938",
  "highcharts": "/highcharts/static-8.102",
  "hs-promise-utils": "/hs-promise-utils/static-1.5531",
  "hs-test-utils": "/hs-test-utils/static-1.7950",
  "hub-http": "/hub-http/static-1.6157",
  "hubspot-dlb": "/hubspot-dlb/static-2.1832",
  "HubStyleTokens": "/HubStyleTokens/static-2.11397",
  "I18n": "/I18n/static-7.1610",
  "jasmine-immutable": "/jasmine-immutable/static-1.2955",
  "jasmine-runner": "/jasmine-runner/static-1.6406",
  "lodash": "/lodash/static-1.3",
  "quartz": "/quartz/static-1.6930",
  "react": "/react/static-7.184",
  "react-dlb": "/react-dlb/static-1.77",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-redux": "/react-redux/static-7.70",
  "react-rhumb": "/react-rhumb/static-1.16597",
  "reporting-data": "/reporting-data/static-1.67207",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.9140",
  "reporting-visualizations": "/reporting-visualizations/static-1.59283",
  "tinymce": "/tinymce/static-6.5",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4706",
  "webpack-env": "/webpack-env/static-1.54",
  "atom": "/atom/static-1.5007",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2431",
  "classnames": "/classnames/static-2.10",
  "cssUtils": "/cssUtils/static-1.778",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39512",
  "customer-data-objects": "/customer-data-objects/static-1.7598",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8019",
  "data-fetching-client": "/data-fetching-client/static-1.9611",
  "enviro": "/enviro/static-4.428",
  "FireAlarmUi": "/FireAlarmUi/static-1.4465",
  "flux-actions": "/flux-actions/static-1.329",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85656",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4656",
  "foundations-components": "/foundations-components/static-1.7802",
  "history": "/history/static-4.47",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4049",
  "HubStyle": "/HubStyle/static-2.11705",
  "icons": "/icons/static-2.643",
  "immutable": "/immutable/static-2.77",
  "isMobile": "/isMobile/static-1.7",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.7095",
  "metrics-js": "/metrics-js/static-1.9542",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "pdf-js": "/pdf-js/static-2.49",
  "PortalIdParser": "/PortalIdParser/static-2.388",
  "property-description-translator": "/property-description-translator/static-1.3784",
  "property-translator": "/property-translator/static-1.5339",
  "quartz-config": "/quartz-config/static-1.708",
  "quartz-core": "/quartz-core/static-1.6149",
  "quick-fetch": "/quick-fetch/static-1.3868",
  "raven": "/raven/static-3.5829",
  "react-dom": "/react-dom/static-7.85",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-router-dom": "/react-router-dom/static-5.26",
  "react-select-plus": "/react-select-plus/static-1.103",
  "react-utils": "/react-utils/static-2.5295",
  "react-virtualized": "/react-virtualized/static-2.97",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.8106",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8028",
  "report-customization-components": "/report-customization-components/static-1.12937",
  "reporting-enablement": "/reporting-enablement/static-1.22638",
  "reporting-reports": "/reporting-reports/static-1.66885",
  "reporting-snowflake": "/reporting-snowflake/static-1.55825",
  "reporting-ui-components": "/reporting-ui-components/static-2.64478",
  "reselect": "/reselect/static-2.16",
  "rpc-client-utils": "/rpc-client-utils/static-1.4581",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.8873",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9147",
  "sanitize": "/sanitize/static-1.4409",
  "sanitize-text": "/sanitize-text/static-1.8081",
  "self-service-api": "/self-service-api/static-1.10182",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1683",
  "signup-constants": "/signup-constants/static-1.18729",
  "signup-ui-lego-core": "/signup-ui-lego-core/static-1.20739",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7972",
  "styled-components": "/styled-components/static-2.88",
  "StyleGuideUI": "/StyleGuideUI/static-3.485",
  "superstore": "/superstore/static-1.4705",
  "transmute": "/transmute/static-2.85",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10927",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11087",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9481",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17893",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10936",
  "ui-images": "/ui-images/static-2.1138",
  "UIComponents": "/UIComponents/static-3.8344",
  "usage-tracker": "/usage-tracker/static-1.7273",
  "usage-tracker-container": "/usage-tracker-container/static-1.7263",
  "usage-tracker-core": "/usage-tracker-core/static-1.7123",
  "usage-tracker-public": "/usage-tracker-public/static-1.7084",
  "viral-links-lib": "/viral-links-lib/static-1.6988",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5489",
  "raven-hubspot": "/raven-hubspot/static-1.6136",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3355",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3207",
  "quartz-webpack": "/quartz-webpack/static-1.3154",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8770",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.58",
  "foundations-assets": "/foundations-assets/static-1.4789",
  "foundations-theming": "/foundations-theming/static-1.4352",
  "quartz-auth": "/quartz-auth/static-1.605",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8980",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4959",
  "foundations-theming-base": "/foundations-theming-base/static-1.3337",
  "HeadJS": "/HeadJS/static-2.740",
  "framer-motion": "/framer-motion/static-1.70",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3061",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.150",
  "hs-locale-management": "/hs-locale-management/static-1.35",
  "i18n-data": "/i18n-data/static-1.219",
  "moment-timezone": "/moment-timezone/static-5.81",
  "jasmine": "/jasmine/static-4.4261",
  "csstype": "/csstype/static-1.50",
  "quartz-head": "/quartz-head/static-1.595",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7862",
  "graphql": "/graphql/static-1.80",
  "immer": "/immer/static-1.33",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3542",
  "persist-promise": "/persist-promise/static-1.3646",
  "quartz-i18n": "/quartz-i18n/static-1.605",
  "reporting-client-types": "/reporting-client-types/static-1.2454",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.827",
  "hs-story-utils": "/hs-story-utils/static-1.9366",
  "react-flip-move": "/react-flip-move/static-1.68",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9810",
  "hubspotter-http": "/hubspotter-http/static-1.4603",
  "sassPrefix": "/sassPrefix/static-1.154",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7187",
  "crm-message-bus": "/crm-message-bus/static-1.42795",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21947",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12958",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13092",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9763",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3961",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6717",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6812",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3793",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.913",
  "onboarding-tours": "/onboarding-tours/static-1.16473",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13471",
  "ui-addon-teams": "/ui-addon-teams/static-1.21463",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "ContentUtils": "/ContentUtils/static-1.68157",
  "customer-data-properties": "/customer-data-properties/static-1.51302",
  "forms-ai-lib": "/forms-ai-lib/static-1.4211",
  "forms-utils-lib": "/forms-utils-lib/static-1.12456",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5285",
  "react-dnd-compat": "/react-dnd-compat/static-1.4556",
  "react-tinymce": "/react-tinymce/static-1.55048",
  "tinymce-config": "/tinymce-config/static-2.54174",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10283",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4071",
  "floating-ui": "/floating-ui/static-1.54",
  "react-aria": "/react-aria/static-1.64",
  "tanstack-table": "/tanstack-table/static-1.53",
  "trellis-assets": "/trellis-assets/static-1.1621",
  "ui-fonts": "/ui-fonts/static-1.659",
  "dispatcher": "/dispatcher/static-1.135",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.826",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.514",
  "module-federation": "/module-federation/static-1.21",
  "quartz-routing": "/quartz-routing/static-1.360",
  "quartz-test": "/quartz-test/static-1.605",
  "quartz-tracking": "/quartz-tracking/static-1.309",
  "batch-promise": "/batch-promise/static-1.1489",
  "external-options-client-types": "/external-options-client-types/static-1.4110",
  "react-colorpicker": "/react-colorpicker/static-2.10146",
  "copilot-toolkit": "/copilot-toolkit/static-1.10944",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.12700",
  "html-to-image": "/html-to-image/static-1.52",
  "onboarding-scopes": "/onboarding-scopes/static-1.6401",
  "reporting-action-components": "/reporting-action-components/static-1.41115",
  "reporting-filters": "/reporting-filters/static-1.142",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.1522",
  "reporting-plugins": "/reporting-plugins/static-1.10185",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4190",
  "ui-addon-opt": "/ui-addon-opt/static-4.8317",
  "zustand": "/zustand/static-1.72",
  "growth-payments-core": "/growth-payments-core/static-1.25162",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4815",
  "chirp-fetch": "/chirp-fetch/static-1.1819",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4119",
  "merchandise-lib": "/merchandise-lib/static-1.262",
  "emoji-regex": "/emoji-regex/static-1.7",
  "purchase-motions-components": "/purchase-motions-components/static-1.5764",
  "salesImages": "/salesImages/static-1.523",
  "ts-schema": "/ts-schema/static-1.4029",
  "nested-table": "/nested-table/static-1.163",
  "timezone-utils": "/timezone-utils/static-2.5180",
  "bender-build-tools": "/bender-build-tools/static-1.3093",
  "chatspot-core": "/chatspot-core/static-1.20970",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2835",
  "stylex": "/stylex/static-1.31",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9808",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3748",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4094",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3643",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18304",
  "growth-data-modal": "/growth-data-modal/static-1.5322",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3006",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1711",
  "navigation-components": "/navigation-components/static-1.17799",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4687",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.539",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10085",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7466",
  "ui-universal-auth": "/ui-universal-auth/static-1.8894",
  "user-context": "/user-context/static-1.5036",
  "cms-field-types": "/cms-field-types/static-1.4746",
  "content-icons-ui": "/content-icons-ui/static-1.2211",
  "integrations-lib": "/integrations-lib/static-1.15893",
  "calling-global-api": "/calling-global-api/static-1.64261",
  "calling-internal-common": "/calling-internal-common/static-1.31239",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65643",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57937",
  "commerce-products-lib": "/commerce-products-lib/static-1.9273",
  "crm-links": "/crm-links/static-1.6215",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9137",
  "file-manager-components": "/file-manager-components/static-1.23420",
  "google-libphonenumber": "/google-libphonenumber/static-1.36",
  "hs-resources": "/hs-resources/static-1.77",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4175",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.567",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48507",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3917",
  "property-value-citations": "/property-value-citations/static-1.1916",
  "pulse": "/pulse/static-1.488",
  "smart-property-lib": "/smart-property-lib/static-1.6599",
  "tiered-pricing": "/tiered-pricing/static-1.1066",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8988",
  "final-form": "/final-form/static-1.68",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.19716",
  "tinymce-themes": "/tinymce-themes/static-1.56144",
  "data-token-picker": "/data-token-picker/static-1.16287",
  "hub-http-contrib": "/hub-http-contrib/static-1.2978",
  "interframe": "/interframe/static-3.4699",
  "tinymce-data": "/tinymce-data/static-1.40259",
  "tinymce-plugins": "/tinymce-plugins/static-1.57288",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5148",
  "magpie-lib": "/magpie-lib/static-1.5519",
  "magpie-types": "/magpie-types/static-1.4979",
  "simple-logging-lib": "/simple-logging-lib/static-1.2987",
  "content-assistance-lib": "/content-assistance-lib/static-1.7650",
  "dashboard-lib": "/dashboard-lib/static-1.81254",
  "ExportDialog": "/ExportDialog/static-6.10328",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18036",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18028",
  "prosemirror": "/prosemirror/static-1.13",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8633",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8824",
  "feedback-loader": "/feedback-loader/static-1.29177",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4587",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.274",
  "purchase-motions-api": "/purchase-motions-api/static-1.5767",
  "trials-service-types": "/trials-service-types/static-1.3838",
  "react-window": "/react-window/static-1.13",
  "ts-utils-lib": "/ts-utils-lib/static-1.110",
  "markdown-it": "/markdown-it/static-1.6",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.1846",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1739",
  "user-context-client": "/user-context-client/static-1.4548",
  "idb-keyval": "/idb-keyval/static-1.42",
  "nest": "/nest/static-1.160",
  "reactive-lib": "/reactive-lib/static-1.659",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.689",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17422",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13308",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5533",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7722",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10310",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.408",
  "calling-error-reporting": "/calling-error-reporting/static-1.31245",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10974",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6477",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.715",
  "customer-data-tracking": "/customer-data-tracking/static-1.6821",
  "commerce-permissions": "/commerce-permissions/static-1.703",
  "products-iframe-lib": "/products-iframe-lib/static-1.7734",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10192",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9033",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "immerable": "/immerable/static-1.4089",
  "video-components-external": "/video-components-external/static-1.11048",
  "video-data-lib": "/video-data-lib/static-1.34706",
  "directed-graph": "/directed-graph/static-1.874",
  "event-emitter": "/event-emitter/static-1.884",
  "fast-json-patch": "/fast-json-patch/static-1.61",
  "data-agent-kit": "/data-agent-kit/static-1.88",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9893",
  "fsm": "/fsm/static-1.3671",
  "policy-lib": "/policy-lib/static-1.6712",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9956",
  "navigation-messaging": "/navigation-messaging/static-1.7126",
  "FileManagerLib": "/FileManagerLib/static-1.39060",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9015",
  "FileManagerCore": "/FileManagerCore/static-1.38919",
  "codemirror": "/codemirror/static-5.93",
  "layout-dnd-components": "/layout-dnd-components/static-1.12316",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11291",
  "react-codemirror": "/react-codemirror/static-1.10560",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9823",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.14946",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8633",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28351",
  "redux-actions": "/redux-actions/static-3.7",
  "knowledge-content-types": "/knowledge-content-types/static-1.8479",
  "payment-link-components": "/payment-link-components/static-1.23338",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24228",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14617",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2945",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.35",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.135",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35492",
  "sales-views-client-types": "/sales-views-client-types/static-1.4199",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3562",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12026",
  "content-media-compositions": "/content-media-compositions/static-2.16033",
  "media-bridge-lib": "/media-bridge-lib/static-1.18810",
  "trellis-story-utils": "/trellis-story-utils/static-1.4454",
  "storybook-react": "/storybook-react/static-1.31",
  "audio-components": "/audio-components/static-1.5814",
  "FileManagerImages": "/FileManagerImages/static-1.36571",
  "video-components": "/video-components/static-1.13051",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4468",
  "video-embed": "/video-embed/static-1.35540",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.68232",
  "layout-data-lib": "/layout-data-lib/static-1.9616",
  "browser-eslint": "/browser-eslint/static-2.57",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6519",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5972",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5020",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3576",
  "draft-convert": "/draft-convert/static-2.71",
  "draft-extend": "/draft-extend/static-3.73",
  "draft-js": "/draft-js/static-5.76",
  "draft-plugins": "/draft-plugins/static-2.21555",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3779",
  "social-insights-client-types": "/social-insights-client-types/static-1.21881",
  "outpost": "/outpost/static-1.4125",
  "advanced-menus-core": "/advanced-menus-core/static-1.15025",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11980",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33855",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15024",
  "simple-menus-lib": "/simple-menus-lib/static-1.16541"
}
};
